import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class IntramirrorSizeMapApiClient extends AdvancedApiClient {

    static entityType = "IntramirrorSizeMap"

    constructor(token, sizeId, id) {
        super();

        this.setEntityType(IntramirrorSizeMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/size/{sid}/intramirror-map/{id}")
                .setRouteParam("sid", sizeId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/size/{sid}/intramirror-map")
                .setRouteParam("sid", sizeId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}